// client/src/components/EditPOI_parts/EditPOI_MoveTypeModal.js
import React from 'react';

export default function EditPOIMoveTypeModal({
  open,
  typeMoveMode,
  setTypeMoveMode,
  typeMoveTargetExistingId,
  setTypeMoveTargetExistingId,
  typeMoveTargetNewName,
  setTypeMoveTargetNewName,
  typeMoveTypeOptions,
  typeMoveablePois,
  selectedOtherPoiIds,
  onToggleOtherPoi,
  onConfirm,
  onClose,
}) {
  if (!open) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: '#0009',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10000,
      }}
    >
      <div
        style={{
          width: 560,
          maxWidth: '92vw',
          background: '#232427',
          color: '#e2e4e9',
          borderRadius: 14,
          boxShadow: '0 10px 28px #000c',
          padding: 20,
        }}
      >
        <div style={{ fontWeight: 800, fontSize: 18, marginBottom: 6 }}>Move to Type</div>
        <div style={{ color: '#c9cbcf', fontSize: 13, marginBottom: 14 }}>
          Choose a target type for this POI. Optionally move other POIs that currently share this
          type.
        </div>

        <div style={{ marginBottom: 14 }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <input
              type="radio"
              name="typeMoveMode"
              checked={typeMoveMode === 'existing'}
              onChange={() => setTypeMoveMode('existing')}
            />
            <span>Choose existing type</span>
          </label>
          {typeMoveMode === 'existing' && (
            <div style={{ marginTop: 6 }}>
              <select
                value={typeMoveTargetExistingId}
                onChange={e => setTypeMoveTargetExistingId(e.target.value)}
                style={{
                  width: '100%',
                  background: '#333',
                  color: '#fff',
                  border: '1px solid #444',
                  borderRadius: 8,
                  padding: '10px 12px',
                }}
              >
                {typeMoveTypeOptions.length === 0 && (
                  <option value="">No other types available</option>
                )}
                {typeMoveTypeOptions.map(t => (
                  <option key={t.id} value={t.id}>
                    {t.label}
                  </option>
                ))}
              </select>
            </div>
          )}

          <div style={{ marginTop: 10 }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <input
                type="radio"
                name="typeMoveMode"
                checked={typeMoveMode === 'new'}
                onChange={() => setTypeMoveMode('new')}
              />
              <span>Create new type</span>
            </label>
            {typeMoveMode === 'new' && (
              <input
                value={typeMoveTargetNewName}
                onChange={e => setTypeMoveTargetNewName(e.target.value)}
                placeholder="New type name"
                style={{
                  marginTop: 6,
                  width: '100%',
                  background: '#333',
                  color: '#fff',
                  border: '1px solid #444',
                  borderRadius: 8,
                  padding: '10px 12px',
                }}
              />
            )}
          </div>
        </div>

        <div style={{ marginBottom: 10 }}>
          <div style={{ fontWeight: 700, marginBottom: 6 }}>Other POIs with This Type</div>
          {typeMoveablePois.length === 0 ? (
            <div style={{ fontSize: 13, color: '#9aa0a6' }}>
              No other POIs currently use this type.
            </div>
          ) : (
            <div
              style={{
                maxHeight: 220,
                overflow: 'auto',
                border: '1px solid #3a3a3a',
                borderRadius: 8,
                padding: 8,
              }}
            >
              {typeMoveablePois.map(p => (
                <label
                  key={p.id}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    padding: '6px 4px',
                  }}
                >
                  <input
                    type="checkbox"
                    checked={selectedOtherPoiIds.has(p.id)}
                    onChange={() => onToggleOtherPoi(p.id)}
                  />
                  <span>
                    {p.name}
                    {p.typeName ? ` (${p.typeName})` : ''}
                  </span>
                </label>
              ))}
            </div>
          )}
          <div style={{ fontSize: 12, color: '#9aa0a6', marginTop: 6 }}>
            The current POI is always moved.
          </div>
        </div>

        <div
          style={{
            marginTop: 18,
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 10,
          }}
        >
          <button
            onClick={onClose}
            style={{
              background: '#444',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              padding: '8px 16px',
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            style={{
              background: '#4cc153',
              color: '#101314',
              border: 'none',
              borderRadius: 8,
              padding: '8px 16px',
              fontWeight: 800,
              cursor: 'pointer',
            }}
          >
            Move
          </button>
        </div>
      </div>
    </div>
  );
}
